export class Plan {
  id: number;
  name: string;
  deliveries: number;
  priceBRL: number;
  priceUSD: number;
  show: boolean;

  getPlanPrice(isEnglish = true) {
    if (isEnglish) {
      if (this.priceUSD === 0) {
        return "Free";
      }
      if (typeof this.priceUSD !== "number" || !(this.priceUSD > 1)) {
        return "Custom";
      }
      return Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(this.priceUSD);
    }
    if (this.priceBRL === 0) {
      return "Grátis";
    }
    if (typeof this.priceBRL !== "number" || !(this.priceBRL > 1)) {
      return "Sob demanda";
    }
    return Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(this.priceBRL);
  }
}
